import { Grid } from "@mui/material";
import React from "react";

interface ErrorFallbackProps {
  errorMessage?: string;
}

const ErrorFallback = ({ errorMessage }: ErrorFallbackProps) => {
  return (
    <Grid
      container
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height={"100vh"}
      sx={(theme) => ({
        color: theme.palette.primary.main,
      })}
    >
      <Grid item>
        <h1>Oops! Something went wrong.</h1>
      </Grid>
      <Grid item>
        <h3>Please try again later.</h3>
      </Grid>
      {errorMessage && (
        <Grid item>
          <h5>{errorMessage}</h5>
        </Grid>
      )}
    </Grid>
  );
};

export default ErrorFallback;
